export interface InvoiceLine {
  id: string;
  descripcion: string;
  cantidad: number;
  precio_unitario: number;
  iva: number;
}

export interface Invoice {
  id: string;
  numero: string;
  fecha: string;
  fecha_vencimiento: string;
  estado: 'borrador' | 'emitida' | 'pagada' | 'cancelada';
  // Cliente
  cliente_nombre: string;
  cliente_nif: string;
  cliente_direccion: string;
  cliente_email: string;
  cliente_telefono: string;
  // Líneas
  lineas: InvoiceLine[];
  // Notas
  notas: string;
  // Calculados
  subtotal: number;
  total_iva: number;
  total: number;
}

export const ESTADO_LABELS: Record<Invoice['estado'], string> = {
  borrador: 'Borrador',
  emitida: 'Emitida',
  pagada: 'Pagada',
  cancelada: 'Cancelada',
};

export const ESTADO_COLORS: Record<Invoice['estado'], string> = {
  borrador: 'bg-zinc-700 text-zinc-300',
  emitida: 'bg-yellow-400/20 text-yellow-400',
  pagada: 'bg-green-500/20 text-green-400',
  cancelada: 'bg-red-500/20 text-red-400',
};

export function calcularTotales(lineas: InvoiceLine[]) {
  const subtotal = lineas.reduce((acc, l) => acc + l.cantidad * l.precio_unitario, 0);
  const total_iva = lineas.reduce((acc, l) => acc + l.cantidad * l.precio_unitario * (l.iva / 100), 0);
  const total = subtotal + total_iva;
  return { subtotal, total_iva, total };
}

export function generarNumeroFactura(existentes: Invoice[]): string {
  const year = new Date().getFullYear();
  const nums = existentes
    .map((f) => {
      const m = f.numero.match(/(\d+)$/);
      return m ? parseInt(m[1], 10) : 0;
    })
    .filter((n) => !isNaN(n));
  const next = nums.length > 0 ? Math.max(...nums) + 1 : 1;
  return `FAC-${year}-${String(next).padStart(4, '0')}`;
}
